<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px;"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
    <br>
    <v-card style="margin-top:-10px">
      <v-row justify="center">
        <v-col sm="3">
          <h3>Join Group</h3>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col sm="3">
          <v-text-field label="Group Code" v-model="group_code" hint="For example, ABC123, 145XYZ" outlined
            dense></v-text-field>
        </v-col>
        <v-col sm="3">
          <v-select :items="student_list" class="padding-bot" item-text="name" item-value="id" outlined dense required
            v-model="sel_student_list"></v-select>
          <!-- <v-combobox dense required item-text="Children" label="Children" outlined /> -->
        </v-col>
        <v-col sm="3">
          <v-btn color="brand onBrand--text" @click="addMemberUsingCodeMultiple">Join Group</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <br />
    <v-card class="main" v-if="comm_groups_users.length > 0">
      <v-data-table :headers="headers" :items="comm_groups_users" class="elevation-1" item-key="id">
        <template v-slot:top>
          <v-toolbar flat color="#ffffcc">
            <v-toolbar-title>Communication Groups </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-card>

    <!-- <v-card>
      <communication-group v-if="addToGroup==true" :group_code="group_code"></communication-group>
    </v-card> -->
    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Student Join Group Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/3dHSngR2IHY?si=D6TilN4CbOfm6Zw0"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
 data: () => ({
      student_list:[],
      group_code: null,
      addToGroup: false,
      snackbar:false,
      videoDialog:false,
   sel_student_list: [],
  //  extraBreadcrumbItems: [


  //  ],
  //  breadcrumbClass: "breadcrumb-style1",
      snackbar_msg: "",
      snackbar: false,
      color: "",
        comm_groups_users:[],
        headers: [
          { text: "Title", value: 'title' },
          { text: "Description", value: 'description' },
          { text: "Groupcode", value: 'groupcode' },
          { text: "Createdby", value: 'createdby' },
          { text: "JoinedBy", value: 'joinedby' },
        ]
  }),
  mounted() {
    this.onload();
  },
  methods: {
    onload(){
    axios
      .post("/CommunicationGroup/getDataforJoinGroup")
      .then(res => {
        if (res.data.msg == "200") {
          this.student_list = res.data.childList
          this.comm_groups_users=res.data.comm_groups_users
        }
      })
      .catch(error => {
        alert("Somthing went wrong!!!");
      })
      .finally(() => {
        //stop loader
      });
    },
    showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
    addMemberUsingCodeMultiple() {
     const formData = {
        group_code: this.group_code,
        stud_list:this.sel_student_list
      };
      axios
        .post("/CommunicationGroup/addMemberUsingCodeMultiple", formData)
        .then(res => {
          console.log(res.data);
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Joined Successfully..."); // show snackbar
            this.onload();
          } else if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", "Group Code Doesn't Matched..."); // show snackbar
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          //stop loader
          //   this.tt_load = false;
        });
    }
  }
  //   methods:{
  //   }
};
</script>